function article_1() {
	return {
		date: "25 March 2023",
		title: "A Learning Approach For GraphQL",
		description:
			"GraphQL is a query language and runtime for APIs that was developed by Facebook. It allows clients to specify the structure of the data they need, and the server responds with only that data. This helps to reduce the amount of data transferred over the network, and enables clients to fetch all the data they need in a single request, rather than making multiple requests to different endpoints. It's commonly used as an alternative to REST APIs.",
	};
}

const myArticles = [article_1];

export default myArticles;
